const press = {
  title: 'Shop at italist | What they say about us',
  description: 'Shop with italist around the world. Read what they say about us',
};

export default press;
